import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logAnalyticsEvent } from '../services/analyticsService';

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        logAnalyticsEvent('page_view', {
            page_path: location.pathname + location.search,
            page_title: document.title,
            page_location: window.location.href
        });
    }, [location]);

    return null;
};

export default AnalyticsTracker;
